import Selector from 'components/Selector'

const TwinMessageContextSizeOptions = ['16', '32', '48', '64', '80', '96']

const MessageMaxContextSizeSelector = ({
  maxContextSize,
  setMaxContextSize,
  isDarkBackdrop,
}: {
  maxContextSize: string
  setMaxContextSize: (maxContextSize: string) => void
  isDarkBackdrop: boolean // used to conditionally style label text color, sometimes this component is on a light / dark backdrop
}) => {
  return (
    <Selector
      id="message-max-context-size-selector"
      label="Max context size"
      option={maxContextSize}
      options={TwinMessageContextSizeOptions}
      setOption={setMaxContextSize}
      isDarkBackdrop={isDarkBackdrop}
      width="240px"
    />
  )
}

export default MessageMaxContextSizeSelector
